window.theme = window.theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


theme.init = function() {
  theme.customerTemplates.init();
};

$(theme.init);

//  document.addEventListener("DOMContentLoaded", function () {
//     const cartMeta = document.querySelector(".cart__meta-text");
//     if (cartMeta) {
//       const nodes = cartMeta.childNodes;
//       nodes.forEach(node => {
//         if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("_essential_preorder_campaign_id")) {
//           node.remove();
//         }
//         if (node.nodeType === Node.ELEMENT_NODE && node.innerText.includes("_essential_preorder_campaign_id")) {
//           node.remove();
//         }
//       });

//       const message = document.createElement("p");
//       message.textContent =
//         "Preorder and Save 15% Some items are out of stock due to high demand. Pre-order & SAVE another 15% off for any out of stock items! We’ll ship as soon as it’s ready and notify you. See Pre-order Terms for more information.";
//       message.style.fontSize = "14px"; // optional styling
//       message.style.marginTop = "8px";
//       cartMeta.appendChild(message);
//     }
//   });
//   document.addEventListener("DOMContentLoaded", function() {
//   const cartMeta = document.querySelector(".cart__meta-text");
//   if (cartMeta) {
//     // Remove all nodes except <p>
//     Array.from(cartMeta.childNodes).forEach(node => {
//       if (!(node.nodeType === 1 && node.tagName.toLowerCase() === "p")) {
//         cartMeta.removeChild(node);
//       }
//     });
//   }
// });








